<template>
  <div
    v-b-tooltip.hover
    title="Reset"
    class="icon-reset-wrp d-flex justify-content-center align-item-center"
    :class="[{ 'icon-active': isActive && editorSelectId }]"
  >
    <undo-icon class="icon-reset" />
  </div>
</template>

<script>
import UndoIcon from "@/@core/components/svg/code-template/UndoIcon.vue";

export default {
  components: { UndoIcon },
  props: {
    editorData: null,
    editorSelectId: null,
    isActive: false,
  },
  setup() {},
};
</script>

<style scoped>
.icon-active {
  background-color: #0058a2 !important;
  cursor: pointer !important;
}
</style>
